import { AuthFlow, type AuthState } from 'types';
import { LOGIN_PROVIDERS } from 'types/enums.ts';
import { STORAGE_KEYS } from 'types/storage';
import { STORE_KEYS } from 'types/store';
import { EXTERNAL_LOGIN_PATH, INTERNAL_LOGIN_PATH } from 'utils/navigation/urls';
import { createKeycloakLogoutRedirect, DEFAULT_LOGOUT_PATH } from './keycloak/logout';

type StoredAuth = Pick<AuthState, 'idToken' | 'tokenProvider' | 'authFlow'>;

export const getStoredAuthSession = (): AuthState | null => {
  try {
    const raw = sessionStorage.getItem(STORE_KEYS.AUTH);

    return raw ? (JSON.parse(raw) as AuthState) : null;
  } catch {
    return null;
  }
};

const clearStoredAuthSession = () => {
  sessionStorage.clear();
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
};

export const isLegacyOauthSession = (auth?: StoredAuth | null): boolean =>
  auth?.tokenProvider === LOGIN_PROVIDERS.GOOGLE || auth?.tokenProvider === LOGIN_PROVIDERS.MICROSOFT;

export const createLogoutRedirect = (auth?: StoredAuth | null, origin = window.location.origin): string => {
  if (auth && !isLegacyOauthSession(auth)) {
    const loginPath = auth.authFlow === AuthFlow.Internal ? INTERNAL_LOGIN_PATH : EXTERNAL_LOGIN_PATH;

    return createKeycloakLogoutRedirect(auth.idToken, origin, loginPath);
  }

  return DEFAULT_LOGOUT_PATH;
};

export const logoutStoredSession = (auth?: StoredAuth | null, origin = window.location.origin) => {
  const logoutUrl = createLogoutRedirect(auth ?? getStoredAuthSession(), origin);

  clearStoredAuthSession();
  window.location.assign(logoutUrl);
};
